import addBusinessDays from "date-fns/addBusinessDays";

export const getSortedCart = (quantityPerSize, colors, sizes) => {
  const sortedSized = quantityPerSize.sort((a, b) => (getIndex(a.size, sizes) > getIndex(b.size, sizes) ? -1 : 1));
  return sortedSized.sort((a, b) => (getIndex(a.color, colors) > getIndex(b.color, colors) ? 1 : -1));
};

/**
 * Retrieves index based on size name
 * @param value
 * @returns  integer as index
 */
const getIndex = (value: string, options: any) => {
  return options.find((el) => el.key == value)?.id;
};


/**
 * Sort products based on creation date
 * @param productCart
 * @returns  integer as index
 */
export const getSortedWholeCart = (productCart) => {
  return productCart.sort((a, b) => (new Date(a.creationDate.toString()) > new Date(b.creationDate.toString()) ? 1 : -1));
};


export const getDeliveryDate = (sessionOrder) => {
    return sessionOrder.deliveryDate || addBusinessDays(new Date(), 3)
};
